import React from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CListGroup, CListGroupItem, CFormCheck } from '@coreui/react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap';
import dayjs from 'dayjs';

// Компонент для створення плану робіт
const CreateWorkPlan = (props) => {
   const navigate = useNavigate();


   // console.log('component')
   return (
      <CForm onSubmit={props.handleSubmit} className="mb-3">

         <div className="mb-3">
            <CFormLabel>Період плану</CFormLabel>
            <div style={{ fontWeight: "bold", fontSize: "1.05rem" }}>
               {dayjs(props.weekStart).format("DD.MM.YYYY")} –{" "}
               {dayjs(props.weekEnd).format("DD.MM.YYYY")}
            </div>
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
            <AsyncSelect
               cacheOptions
               loadOptions={props.loadOptionsPartners}
               defaultOptions
               value={props.selectedOptionPartner}
               onChange={props.handleChangePartner}
               className="flex-grow-1"
            />
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Підрозділ</CFormLabel>
            <AsyncSelect
               cacheOptions
               loadOptions={props.loadOptionsFactories}
               defaultOptions
               value={props.selectedOptionFactories}
               onChange={props.handleChangeFactories}
               className="flex-grow-1"
            />
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Договори</CFormLabel>
            {/* <AsyncSelect */}
            <Select
               cacheOptions
               // loadOptions={loadOptionsEngineers}
               options={props.agreementsOptions}
               defaultOptions
               value={props.selectedAgreement}
               onChange={props.handleChangeAgreement}
               className="flex-grow-1"
            />
         </div>

         {/* селект з інженером */}
         {/* <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Інженери</CFormLabel>
            <Select
               cacheOptions
               options={props.engineers}
               defaultOptions
               value={props.selectedOptionEngineers}
               onChange={props.handleChangeEngineers}
               className="flex-grow-1"
            />
         </div> */}

         {/* опціі з графіками робіт */}
         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Графіки робіт</CFormLabel>
            {/* <AsyncSelect */}
            <Select
               cacheOptions
               options={props.graphs}
               defaultOptions
               value={props.selectedGraph}
               onChange={props.handleChangeGraph}
               className="flex-grow-1"
            />
         </div>

         {/* селект з інженером */}
         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Інженери</CFormLabel>
            <Select
               cacheOptions
               options={props.engineers}
               defaultOptions
               value={props.selectedOptionEngineers}
               onChange={props.handleChangeEngineers}
               className="flex-grow-1"
            />
         </div>

         {/*інпут з будівельником */}
         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput2">Будівельник</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput2"
               // value={props.description}
               // onChange={(e) => props.setDescription(e.target.value)}
               value='Головний будівельник'
               autoComplete="off"
               disabled
            />
         </div>





         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput2">Опис</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput2"
               value={props.description}
               onChange={(e) => props.setDescription(e.target.value)}
               autoComplete="off"
            />
         </div>


         <Col>
            {props.selectedGraph === '' ? <CButton
               onClick={props.handleSubmit}
               // type="submit"
               color="success" disabled={props.selectedGraph !== ''}>
               Зберегти
            </CButton> : ''}
            {props.selectedGraph !== '' ? <CButton
               // type="submit"
               color="success"
               className='ml-3'
               onClick={() => {
                  props.copyWorkPlanFromWorkGraph(props.workGraph)
                  // navigate(props.urlRouter)
               }}
            >
               Створити згідно графіка робіт
            </CButton> : ''}

            <Link to={props.urlRouter} className="ms-3">
               <CButton
                  // type="submit"
                  color="secondary">
                  Відміна
               </CButton>
            </Link>
         </Col>

      </CForm>

   );
};

export default CreateWorkPlan;